// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-editor.mode-markdown.alternative-wysiwyg .switch-mode {
  top: 25px;
}`, "",{"version":3,"sources":["webpack://./src/editor/modes/markdown.scss"],"names":[],"mappings":"AAAA;EACC,SAAA;AACD","sourcesContent":[".text-editor.mode-markdown.alternative-wysiwyg .switch-mode {\n\ttop: 25px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
